import React, { useState, useEffect } from 'react';

export default function SmallThumbnails({
	generatingThumb,
	images,
	store,
	currentActivevPage,
}) {
	const [errorImages, setErrorImages] = useState({});
	const [loadingImages, setLoadingImages] = useState({});
	const [retryCount, setRetryCount] = useState({});

	useEffect(() => {
		// Reset states when images prop changes
		setErrorImages({});
		setLoadingImages({});
		setRetryCount({});
	}, [images]);

	const handleImageError = (id) => {
		const currentRetry = retryCount[id] || 0;
		if (currentRetry < 3) {
			// Retry loading the image
			setRetryCount((prev) => ({ ...prev, [id]: currentRetry + 1 }));
			setLoadingImages((prev) => ({ ...prev, [id]: true }));
			setTimeout(() => {
				const img = new Image();
				img.onload = () => handleImageLoad(id);
				img.onerror = () => {
					if (currentRetry + 1 >= 3) {
						setErrorImages((prev) => ({ ...prev, [id]: true }));
						setLoadingImages((prev) => ({ ...prev, [id]: false }));
					}
				};
				img.src = images.find((img) => img.id === id)?.image;
			}, 1000);
		} else {
			setErrorImages((prev) => ({ ...prev, [id]: true }));
			setLoadingImages((prev) => ({ ...prev, [id]: false }));
		}
	};

	const handleImageLoad = (id) => {
		setLoadingImages((prev) => ({ ...prev, [id]: false }));
		setErrorImages((prev) => ({ ...prev, [id]: false }));
	};



	return (
		<div className='all-sm-pages-list'>
			<div className='all-sm-pages-items'>
				{images?.map(({ id, image, label }, index) => (
					<div
						key={index}
						className={`sm-page-item ${
							currentActivevPage === id ? 'selected' : ''
						}`}
						// ${id === "master" ? "active" : isActive ? "active" : ""}
						// `}
						onClick={() => {
							store.selectPage(id);
						}}>
						<span>
							{label === 'Master' ? (
								<>
									<img
										src='/assets/images/flag_icn.svg'
										alt='Flag'
										style={{ marginRight: '5px' }}
									/>
									{label}
								</>
							) : (
								label
							)}
						</span>
						<div className='page-thumb-img'>
							{generatingThumb || loadingImages[id] ? (
								<div className='page-thumb-img page-thumb-img-loader'>
									<div className='loaderItem' id='loader-7'></div>
								</div>
							) : errorImages[id] ? (
								<div className='page-thumb-img-error'>
									<span>Loading...</span>
								</div>
							) : (
								<img
									src={image}
									alt={`Thumbnail ${index}`}
									loading='lazy'
									className='page-img'
									onError={() => handleImageError(id)}
									onLoad={() => handleImageLoad(id)}
								/>
							)}
						</div>
						{/* {image ? (
              <div className="page-thumb-img">
                <img
                  src={image}
                  alt={`Thumbnail ${index}`}
                  loading="lazy"
                  className="page-img"
                />
              </div>
            ) : (
              <div className="page-thumb-img page-thumb-img-loader">
                <div className="loaderItem" id="loader-7"></div>
              </div>
            )} */}
					</div>
				))}
			</div>
		</div>
	);
}
